import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/temp/mail-unread.svg")